<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 48 48"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="M21.059 23.802a.8.8 0 0 0-.235-1.107L4.382 12.009a.8.8 0 0 0-1.236.67v21.372a.8.8 0 0 0 1.236.671l16.442-10.686a.8.8 0 0 0 .235-.234zM5.47 36.399a2.8 2.8 0 0 1-4.325-2.348V12.68a2.8 2.8 0 0 1 4.325-2.348l16.443 10.686a2.8 2.8 0 0 1 0 4.695L5.47 36.4zm24.617-23.448a1.7 1.7 0 0 0-1.7 1.7v17.43a1.7 1.7 0 0 0 1.7 1.7H31a1.7 1.7 0 0 0 1.7-1.7V14.65a1.7 1.7 0 0 0-1.7-1.7h-.91zm0-2H31a3.7 3.7 0 0 1 3.7 3.7v17.43a3.7 3.7 0 0 1-3.7 3.7h-.91a3.7 3.7 0 0 1-3.7-3.7V14.65a3.7 3.7 0 0 1 3.7-3.7zm11.36 2a1.7 1.7 0 0 0-1.7 1.7v17.43a1.7 1.7 0 0 0 1.7 1.7h.91a1.7 1.7 0 0 0 1.7-1.7V14.65a1.7 1.7 0 0 0-1.7-1.7h-.91zm0-2h.91a3.7 3.7 0 0 1 3.7 3.7v17.43a3.7 3.7 0 0 1-3.7 3.7h-.91a3.7 3.7 0 0 1-3.7-3.7V14.65a3.7 3.7 0 0 1 3.7-3.7z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
